import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);
		this.events = { click: { more: "load" } };
	}

	init() {
		this.id = this.el.getAttribute("data-module-loader");

		this.$filters = Array.from(document.querySelectorAll("[data-module-filters]")).find((el) => {
			try {
				return JSON.parse(el.getAttribute("data-filters-config")).for === this.id;
			} catch (e) {
				return false;
			}
		});

		this.batch = parseInt(this.getData("batch"));
		this.$items = this.el.querySelectorAll('[data-loader="item"]');
		this.$more = this.$("more")[0];
		this.$batch = this.$("batch")[0];
		this.$total = this.$("total")[0];
		this.$index = this.$("index")[0];
		this.$totalExternal = document.querySelectorAll('[data-loader-total="' + this.id + '"]');

		this._filtersAfterHandler = this.reset.bind(this);
		if (this.$filters) this.$filters.addEventListener("after", this._filtersAfterHandler);

		this.reset();
	}

	reset() {
		const $filtered = Array.from(this.$items).filter((n) => n.classList.contains("is-match"));
		const hasActiveFilter = $filtered.length < this.$items.length;

		if (hasActiveFilter) {
			// Filtre actif — affiche tous les items qui matchent
			this.$items.forEach((el) => el.classList.remove("is-loaded"));
			$filtered.forEach((el) => el.classList.add("is-loaded"));
			this.$more.classList.add("u-hidden");
			this.updateUI($filtered);
		} else {
			// Pas de filtre — comportement normal par batch
			this.$items.forEach((el) => el.classList.remove("is-loaded"));
			this.$batch.innerText = this.batch;
			this.$more.classList.remove("u-hidden");
			this.load();
		}
	}

	load() {
		const $filtered = Array.from(this.$items).filter((n) => n.classList.contains("is-match"));

		let lastIndex = $filtered
			.map((n, i) => (n.classList.contains("is-loaded") ? i + 1 : -1))
			.reverse()
			.find((i) => i !== -1);
		lastIndex = !lastIndex ? 0 : lastIndex;

		$filtered.slice(lastIndex, lastIndex + this.batch).forEach((node) => {
			node.classList.add("is-loaded");
		});

		const remaining = Math.max(0, $filtered.length - (lastIndex + this.batch));
		if (remaining < this.batch && remaining > 0) this.$batch.innerText = remaining;
		if (lastIndex + this.batch >= $filtered.length) this.$more.classList.add("u-hidden");

		this.updateUI($filtered);
	}

	updateUI($filtered) {
		const total = $filtered.length;
		const visible = $filtered.filter((n) => n.classList.contains("is-loaded")).length;

		if (this.$total) this.$total.innerText = String(total);
		if (this.$index) this.$index.innerText = String(visible);
		this.$totalExternal.forEach(($el) => ($el.textContent = total ? `(${total})` : ""));
	}

	destroy() {
		if (this.$filters) this.$filters.removeEventListener("filters:after", this._filtersAfterHandler);
	}
}
